import { API_BASE } from "@/lib/api";
import { openFile } from "@/lib/fileViewer";

export const DOC_CATEGORIES = [
  { value: "regolamenti", label: "Regolamenti" },
  { value: "modulistica", label: "Modulistica" },
  { value: "calendari", label: "Calendari" },
  { value: "altro", label: "Altro" },
];

export const DOC_AUDIENCES = [
  { value: "entrambi", label: "Studenti e docenti" },
  { value: "studenti", label: "Solo studenti" },
  { value: "docenti", label: "Solo docenti" },
];

export const categoryLabel = (v) => DOC_CATEGORIES.find((c) => c.value === v)?.label || "Altro";
export const audienceLabel = (v) => DOC_AUDIENCES.find((a) => a.value === v)?.label || v;

export function formatSize(bytes) {
  if (!bytes) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
}

export function openSharedDoc(id, name) {
  const token = localStorage.getItem("token") || "";
  openFile(`${API_BASE}/shared-documents/${id}/download?auth=${encodeURIComponent(token)}`, name);
}
